import * as React from 'react'

import { createContext } from '~logic/lib/react'

type TLayout = {
  isMobile: boolean
  isTablet: boolean
}

const [Provider, useLayoutCtx] = createContext<TLayout>(`Layout`)

type TProps = RequiredChildren & TLayout

/**
 * Provides isMobile and isTablet layout context for shared module if needed.
 * Takes as parameters isMobile and isTablet to allow the use various layout breakpoints for shop/waiter.
 *
 * Target use case:
 *    There is plenty of files for one logic (as product detail) that needs this information,
 *    wrap it and avoid passing those parameters.
 */
export const LayoutProvider: React.FC<TProps> = ({ isMobile, isTablet, children }) => {
  const layout = { isMobile, isTablet }
  return <Provider value={layout}>{children}</Provider>
}

export { useLayoutCtx }
